import React from 'react';
import { NamePath } from 'rc-field-form/lib/interface';

import { RadioInput } from '../../../components/atom/form/radiofield';

type BinaryRadioProps = {
  name: NamePath;
  label: string | React.ReactNode;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
};

export function BinaryRadio(props: BinaryRadioProps) {
  const options = [
    {
      value: true,
      display: 'Yes',
    },
    {
      value: false,
      display: 'No',
    },
  ];
  return <RadioInput options={options} {...props} optionsDirection="horizontal" />;
}
